export default {
  // 导航
  nav: {
    home: '首页',
    about: '关于我们',
    services: '智能业务',
    products: '智能平台',
    computing: '算力中心',
    news: '临科资讯',
    contact: '联系我们',
  },
  hero: {
    title: '引领未来',
    subTitle: '构建下一代AI数据智能，用算力解放人力',
  },
  about: {
    title: '关于临科智华',
    computingTitle: '临科智华',
    subTitle: '企业数据智能服务提供商',
    description:
      '临科智华是一家专注于企业数据智能解决方案的服务商。公司以“用算力解放人力”为使命，推行数据市场全球化策略，积极布局多区域市场。通过采用集装箱式模块化算力架构，能够快速搭建智算中心，在算力性能方面处于行业领先地位，目前已在多个国家及国内多个地区完成布局。公司拥有全链条AI能力平台，为各行业提供快速落地的解决方案，数据处理服务覆盖全流程，能够积累行业核心数据，构建竞争“护城河”，并持续推动产业AI化转型升级。',

    description1:
      '公司以全球布局为蓝图，以智算中心为基础筹码，以AI能力平台为核心载体，以数据处理能力为切入路径，临科智华致力于实现当地核心数据资源的抓取与产业场景化AI应用落地。',
    description2:
      '创始人/董事长 王旭辉，毕业于斯坦福大学，是人工智能、大数据及区块链领域科学家，是美国Scale AI早期核心科学家和图科学项目搭建者， 是中国科学家协会、美国计算机学会（ACM）、国际人工智能学会（AAAI）会员。 ',
    description3:
      '创始人/总裁 王素军，英国威尔士大学MBA，曾任统一企业（中国）全国销售总监，管理线下万人军团操盘年营收百亿级别；上海二三四五网络科技王牌联盟总经理，管理全国最大线下互联网产品推广团队，实现年净利1亿+；拥有逾15年线下实体行业操盘及超10年互联网企业管理经验，拥有超大规模团队管理和市场推广经验。',
    description4:
      '作为上海临港本土培育的高潜力企业，临科智华的发展备受领导及社会各界的广泛关注与支持，公司在成立一周年之际，凭借扎实的技术研发实力与显著的创新潜力，成功通过“国家级科技型中小企业”认定。',
  },
  partners: {
    title: '值得信赖的合作伙伴',
    computingTitle: '合作伙伴',
    subTitle: '与行业领先企业携手共进，共创数据智能新未来',
  },
  dataBusiness: {
    title: '数据智能业务',
    computingTitle: '数据智能',
    subTitle: '提供全方位的数据智能服务，助力企业数智化转型',
    menu1: '多模态数据处理',
    menu2: '智能体搭建',
    menu3: '全球跨境算力支持',
    // tabList: ['多模态数据处理', '智能体搭建', '全球跨境算力支持'],
    tabList: {
      item1: '多模态数据处理',
      item2: '智能体搭建',
      item3: '全球跨境算力支持',
    },
    btnText: '立即咨询',
    btnText1: '申请演示',
    // 标签页内容
    tab1: {
      title: '多模态数据处理',
      subTitle:
        '临科智华提供行业前沿的高质量数据全生命周期处理服务，通过对数据的采集、清洗、预处理、自动化标注、质检等流程为AI模型训练提供坚实基础。',
      modal: '模态',
      modalDesc: '图片、文本、音视频、点云等',
      scene: '场景',
      sceneDesc: '金融、医疗、交通、教育等',
      childTabs: {
        item1: '3D点云',
        item2: '语义分割',
        item3: '具身智能',
        item4: '监督微调',
      },
      btnText: '立即咨询',
    },
    tab2: {
      title: '智能体搭建',
      subTitle:
        '基于先进的数据智能和大模型技术，为各行各业定制专属智能体，支持从知识库搭建到多模态融合应用，全面提升业务效率与决策能力。',
      product: '产品',
      productDesc: '财务智能体、培训智能体、客服智能体等',
      btnText: '申请演示',
    },
    tab3: {
      title: '全球跨境算力支持',
      subTitle:
        '临科智华正在全球范围内构建算力网络，可提供全球化的算力资源调度与管理，满足企业在全球各地的AI训练、推理与数据跨境需求',
      capability: '能力',
      capabilityDesc: '国际网络专线、全球数据与算力跨境、可信数据空间',
      btnText: '立即咨询',
    },
  },
  dataPlatform: {
    title: '数据智能平台',
    computingTitle: '数据智能',
    subTitle: '为企业提供全栈式数据智能平台，加速AI应用落地',
    leftTitle: '数智引擎 LWDE 4.0',
    leftDesc:
      '高效、精准的多模态数据标注与资产管理系统 支持图像、视频、音频、文本、点云等多种数据类型，支持数据资产的跨境管理，赋能全球AI训练与推理任务',
    list: {
      item0: {
        title: '数智引擎 LWDE 4.0',
        descr:
          '高效、精准的多模态数据标注与资产管理系统 支持图像、视频、音频、文本、点云等多种数据类型，支持数据资产的跨境管理，赋能全球AI训练与推理任务',
      },
      item1: {
        title: '多模态模型仓库 MMS 1.5',
        descr:
          '一站式AI模型微调与部署平台，支持多种框架与算法，包含69种主流模型对应39种场景能力，大幅简化模型选择和优化流程',
      },
      item2: {
        title: 'iAgent 2.3',
        descr:
          '低代码智能体开发环境，以拖拽操作快速构建行业AI应用及自动化系统，赋能企业敏捷交付能力',
      },
      item3: {
        title: '异构算力资源管理平台 HCRM 2.1',
        descr:
          '智能化算力资源管理与调度系统，实现全球范围的异构跨境算力资源高效分配、调度与管理，为您的AI项目提供强大算力支撑',
      },
    },
  },
  computingCenter: {
    title: '算力中心建设',
    computingTitle: '算力中心建设',
    subTitle: '全球范围内的超算与智算中心搭建服务',
    cityList: {
      item1: '阿布扎比',
      item2: '塔什干',
      item3: '中国新疆',
      item4: '柔佛',
      item5: '中国香港',
      item6: '中国天津',
      item7: '得克萨斯州',
      item8: '墨西哥城',
    },
  },
  teuContainer: {
    title: '标准集装箱模块化算力解决方案',
    computingTitle: '模块化算力',
    txtInfo: {
      title: 'LWCC-B200 算力集装箱',
      descr:
        '由临科智华打造的LWCC-B200集成超算级硬件与高效基础设施，专为高密度AI训练设计,作为开箱即用的弹性算力底座可适应各类项目场景与需求。',
    },

    list: {
      item1: {
        title: '顶级算力',
        descr:
          '箱体内支持16台NVIDIA Blackwell DGX B200服务器，单箱体提供576PataFLOPS稀疏算力',
      },
      item2: {
        title: '灵活部署',
        descr: '箱体支持部署后拆卸再运输，大幅提升项目灵活性',
      },
      item3: {
        title: '按需定制',
        descr:
          '箱体内个模块（算力、供电、散热等）支持按需定制，可满足全球各地的条款，助力项目顺畅落地',
      },
      item4: {
        title: '高效可靠',
        descr:
          '配备液冷+风冷的双模冷却（PUE≤1.15）的标准机柜，15分钟以上锂电配电与智能运维平台，保障设备安全可靠',
      },
    },
  },
  computingFacilities: {
    title: '重新定义下一代算力基础设施',
    computingTitle: '算力基础设施',

    txtInfo: {
      title: '临科智华模块化智算中心',
      subTitle: '',
      descr:
        '将超算中心、绿色能源、智能控制高度集成于标准集装箱， 为全球AI应用提供高可靠、高弹性、零碳排的算力底座。',
    },

    list: {
      item1: {
        title: '极速交付',
        descr:
          '基于临科智华模块化算力集装箱，实现6-8周生产、2-3天部署的极速交付能力',
      },
      item2: {
        title: '社会责任',
        descr:
          '利用光伏与风电等绿色能源进行制氢储氢，每年可减少约5000吨碳排放，保护蓝色星球的同时拉动更多就业机会与社会福祉',
      },
      item3: {
        title: '全域智控',
        descr:
          '统一平台监控算力、能源、冷却全链路，电力调控单元精准管理发电、储电、供电循环',
      },
      item4: {
        title: '数智跨境',
        descr:
          '基于临科智华异构算力资源管理平台，提供全球范围内AI训练、推理和数据跨境服务',
      },
    },
  },
  news: {
    title: '临科资讯',
  },
  linkWe: {
    title: '联系我们',
    subTitle: '期待与您携手共创数据智能新未来',
    rightTitle: '临科智华专业顾问将给您回电，请保持电话畅通',
    computingTitle: '专业顾问',
    formName: '姓名',
    formNamePlaceholder: '请输入姓名',
    formPhone: '手机号',
    formPhonePlaceholder: '请输入手机号',
    formPosition: '公司名称与职位',
    formPositionPlaceholder: '请输入公司名称与职位',
    formInterest: '感兴趣的业务 ',
    formInterestPlaceholder: '请选择感兴趣的业务',
    formMessage: '留言内容',
    formMessagePlaceholder: '请输入您希望了解的信息',
    btnText: '立即提交',
    txtPhone: '手机',
    txtEmail: '邮箱',
    submitSuc: '提交成功',
    infoList: {
      item1: {
        title: '媒体&政府合作',
        userName: '胡经理',
        phone: '+86 15914210310',
        // email1: 'hufeiyu@linkwise.tech',
      },
      item2: {
        title: '行业解决方案',

        userName: '周经理',
        phone: '+86 13810409176',

        // email1: 'yaozhiqing@linkwise.tech',
        // email2: 'zhoudongxia@linkwise.tech',
      },
      item3: {
        title: '数据处理业务',
        userName: '耿经理',
        phone: '+86 15250500418',
        // email1: 'gengyao@linkwise.tech',
      },
    },
  },
  footer: {
    address:
      '公司地址：上海市浦东新区临港新片区港城广场一街坊9号楼   总部电话：021-60701336',
    copyright:
      'Copyright © 上海临科智华数字科技有限公司    沪ICP备2024079928号-1',
    qrcode: '关注公众号',
    qrcodeText: '了解更多资讯',
  },
};
